

// Template Dashboard 2 MUI Base Styles
import colors from "assets/theme/base/colors";

const { info, dark, grey, background } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  hr: {
    borderBottom: 0,
    borderLeft: 0,
    borderRight: 0,
  },
  "::-webkit-scrollbar": {
    width: "15px",
    height: "15px",
  },
  "::-webkit-scrollbar-track": {
    backgroundColor: background.main, // Scrollbar track color
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: grey[500], // Scrollbar thumb color
    borderRadius: "10px",
    border: `2px solid ${background.main}`, // Padding around the thumb
  },
  "::-webkit-scrollbar-thumb:hover": {
    backgroundColor: grey[700], // Thumb color on hover
  },
};

export default globals;
